import { Component, ChangeDetectionStrategy, ElementRef, HostListener, inject } from '@angular/core';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderComponent {

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  menuOpen = false;
  servicesOpen = false;

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
    if (!this.menuOpen) {
      this.servicesOpen = false;
    }
  }

  toggleServices(event: Event): void {
    event.stopPropagation();
    this.servicesOpen = !this.servicesOpen;
  }

  closeMenus(): void {
    this.menuOpen = false;
    this.servicesOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target as Node)) {
      this.closeMenus();
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closeMenus();
  }
}
